
// import { storeToRefs } from 'pinia'
// import { useLearningAuthStore } from '@stores/auth'
// const { userLogging, resetAuth } = storeToRefs(useLearningAuthStore())

const blockEvent = (event) => {
  event.stopImmediatePropagation()
}

export const defineAllowRoutes = (allowRoutes, rejectRoute) => {
  const arrayAllowedRoutes = Array.isArray(allowRoutes) ? allowRoutes : [allowRoutes]
  return (to, from, next) => {
    if (arrayAllowedRoutes.includes(from.name)) {
      next()
    } else {
      next({ name: rejectRoute })
    }
  }
}

export const saveCustomPosition = (targetClassName, from, router) => {
  if (typeof from.name !== 'undefined') {
    const elTarget = document.querySelector(targetClassName)
    if (typeof from.meta.excludeKeepAlive === 'undefined') {
      router.customSavePosition[from.name] = {
        x: elTarget.scrollLeft,
        y: elTarget.scrollTop
      }
    }
  } else {
    router.customSavePosition = {}
  }
}

export const loadCustomPosition = (targetClassName, from, to, router) => {
  if (typeof from.name !== 'undefined') {
    const elTarget = document.querySelector(targetClassName)
    let scrollPositionX
    let scrollPositionY
    if (typeof to.meta.excludeKeepAlive === 'undefined' && Object.prototype.hasOwnProperty.call(router.customSavePosition, to.name)) {
      scrollPositionX = router.customSavePosition[to.name].x
      scrollPositionY = router.customSavePosition[to.name].y
    } else {
      scrollPositionX = 0
      scrollPositionY = 0
    }
    setTimeout(() => {
      elTarget.scrollLeft = scrollPositionX
      elTarget.scrollTop = scrollPositionY
    }, 0)
  }
}

export const transitionRouterBefore = (targetClassName, from, next) => {
  let nextDuration = 0

  if (typeof from.name !== 'undefined') {
    const elTarget = document.querySelector(targetClassName)

    $logger.weak('Blocked window click event')
    window.addEventListener('click', blockEvent, true)

    elTarget.classList.remove('routerAfter')
    elTarget.classList.add('routerBefore')
    nextDuration = (parseFloat(getComputedStyle(elTarget).transitionDuration) * 1000)
  }
  setTimeout(() => {
    next()
  }, nextDuration)
}

export const transitionRouterAfter = (targetClassName, from) => {
  if (typeof from.name !== 'undefined') {
    const elTarget = document.querySelector(targetClassName)
    setTimeout(() => {
      window.removeEventListener('click', blockEvent, true)
      $logger.weak('Unblocked window click event')
      elTarget.classList.remove('routerBefore')
      elTarget.classList.add('routerAfter')
    }, 0)
  }
}


export const AuthGuard = () => {
  return (to, from, next) => { 
    // try {
    //   if (userLogging) {
    //     next({ name: 'Login' })
    //     return
    //   }
    //   next()
    // } catch (e) {
    //   resetAuth()
    //   next({ name: 'Login' })
    //   throw e
    // }
  }
}